<template>
  <v-dialog v-model="dialog" width="720">
    <template v-slot:activator="{ on }">
      <v-btn tile outlined class="filterButton" v-on="on">
        <span class="buttonTextBlue">NOVO ADM</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="modalTitle">Adicionar Administrador</span>
        <v-btn icon text @click="dialog = false">
          <Icon icon="mdi-close" color="#9E9E9E" size="24" style="cursor: pointer;" />
        </v-btn>
      </v-card-title>
      <v-card-text style="background: #F5F5F5;">
        <v-container>
          <v-row>
            <v-col sm="6">
              <span class="inputLabel">Nome:</span>
              <v-text-field single-line solo flat class="inputTextfield" v-model="name"></v-text-field>
            </v-col>
            <v-col sm="6">
              <span class="inputLabel">Telefone:</span>
              <v-text-field single-line solo flat class="inputTextfield" v-model="phone"></v-text-field>
            </v-col>
            <v-col sm="12">
              <span class="inputLabel">Email:</span>
              <v-text-field single-line solo flat class="inputTextfield" v-model="email"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-col sm="12" class="d-flex align-center justify-space-between">
          <v-btn class="modalButton" text @click="dialog = false">
            <span class="buttonTextBlue">Cancelar</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="modalButton" color="#0012A6" @click="createAdmin()">
            <span class="buttonTextWhite">Adicionar</span>
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import Icon from "@/components/atoms/icon";
export default {
  components: {
    Icon
  },
  data() {
    return {
      dialog: false,
      name: "",
      email: "",
      phone: ""
    };
  },
  methods: {
    remove(item) {
      this.locals.splice(this.locals.indexOf(item), 1);
      this.locals = [...this.locals];
    },
    createAdmin() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/admin/create`,
          {
            name: this.name,
            email: this.email,
            phone: this.phone
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.user.token}`
            }
          }
        )
        .then(() => {
          axios
            .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            })
            .then(res => {
              this.dialog = false;
              this.$store.dispatch("setAccounts", {
                accounts: res.data.data.users
              });
            });
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style scoped>
.modalTitle {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}

.inputLabel {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}

.inputTextfield {
  height: 48px;
  width: 316px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}

.modalButton {
  height: 40px;
  width: 203px;
  border-radius: 5px;
  box-sizing: border-box;
}

.filterButton {
  border: 1px solid #0439d9;
  box-sizing: border-box;
  border-radius: 5px;
  width: 163px;
  height: 40px;
}

.buttonTextBlue {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}

.buttonTextWhite {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #fff;
}
</style>